import React from 'react';
import './leftMenu.css';

const activeBadge = (value) => {
  const isActive = value === true || value === 1 || value === '1' || value === 'true';
  return <span className={`mgr-badge ${isActive ? 'mgr-badge-active' : 'mgr-badge-inactive'}`}>{isActive ? '활성' : '비활성'}</span>;
};

const typeClassMap = { link: 'mgr-badge-type-link', url: 'mgr-badge-type-url', category: 'mgr-badge-type-category', action: 'mgr-badge-type-action' };

function ValueRow({ label, children }) {
  return (
    <tr>
      <th>{label}</th>
      <td>{children}</td>
    </tr>
  );
}

function LeftMenuDetail({ menu, onEdit, onDelete, onCreateItem }) {
  if (!menu) return <div className="mgr-right-empty"><span>메뉴를 선택하세요.</span></div>;

  const isLinkType = menu.type === 'link';
  const isUrlType = menu.type === 'url';
  const isActionType = menu.type === 'action';
  const isCategoryType = menu.type === 'category';

  return (
    <>
      <div className="mgr-panel-header">
        <div>
          <div className="mgr-panel-title">메뉴 조회</div>
          <div className="mgr-panel-subtitle">{menu.label}</div>
        </div>
        <div className="d-flex gap-2">
          {isCategoryType && (
            <button className="btn btn-sm btn-success" onClick={() => onCreateItem && onCreateItem(menu)}>
              + 하위메뉴 생성
            </button>
          )}
          <button className="btn btn-sm btn-outline-primary" onClick={() => onEdit && onEdit(menu)}>수정</button>
          <button className="btn btn-sm btn-outline-danger" onClick={() => onDelete && onDelete(menu)}>삭제</button>
        </div>
      </div>
      <div className="mgr-panel-body">
        <table className="mgr-detail-table">
          <tbody>
            <ValueRow label="메뉴 키">{menu.menu_key || '-'}</ValueRow>
            <ValueRow label="타입"><span className={`mgr-badge ${typeClassMap[menu.type] || ''}`}>{menu.type}</span></ValueRow>
            <ValueRow label="라벨">{menu.label || '-'}</ValueRow>
            <ValueRow label="아이콘">{menu.icon || '-'}</ValueRow>
            {isLinkType && <ValueRow label="경로">{menu.path || '-'}</ValueRow>}
            {isUrlType && <ValueRow label="URL">{menu.url || '-'}</ValueRow>}
            {isUrlType && <ValueRow label="세션 URL">{menu.session_url || '-'}</ValueRow>}
            {isActionType && <ValueRow label="액션">{menu.action || '-'}</ValueRow>}
            {isCategoryType && <ValueRow label="items_from">{menu.items_from || '-'}</ValueRow>}
            {isCategoryType && <ValueRow label="item_id_field">{menu.item_id_field || '-'}</ValueRow>}
            {isCategoryType && <ValueRow label="item_label_field">{menu.item_label_field || '-'}</ValueRow>}
            {isCategoryType && <ValueRow label="path_template">{menu.path_template || '-'}</ValueRow>}
            <ValueRow label="메뉴설명">
              <div style={{ whiteSpace: 'pre-wrap' }}>{menu.menu_context || '-'}</div>
            </ValueRow>
            <ValueRow label="정렬 순서">{menu.sort_order ?? '-'}</ValueRow>
            <ValueRow label="활성 상태">{activeBadge(menu.is_active)}</ValueRow>
          </tbody>
        </table>
      </div>
    </>
  );
}

export default LeftMenuDetail;
